<!--
    Component used in the navbar to display days left for trial plans
 -->

<script setup lang="ts">
/* STORES */
import { ALChip } from '@af-lib/vue-ui';

import { useAuthStore } from '@/stores/auth';

// Init variables to calculate days left
const expiryDateTimestamp = useAuthStore().getCompany.plan_expired_at;
const expiryDate = new Date(new Date(expiryDateTimestamp * 1000).setHours(0, 0, 0, 0));
const currentDate = new Date(new Date().setHours(0, 0, 0, 0));
const difference = expiryDate.getTime() - currentDate.getTime();
const daysLeft = Math.ceil(difference / (1000 * 3600 * 24)) + 1;
</script>

<template>
  <ALChip
    size="s"
    icon="fat fa-location-dot"
    :label="`${$t('plans.trial.name_intro')} ${$t('plans.trial.time_left', { days: daysLeft })}`"
    class="bg-af-teal-500 text-white border-af-teal-500"
  />
</template>
